import { render, staticRenderFns } from "./MatricesList.vue?vue&type=template&id=2b3d4bc2&scoped=true&"
import script from "./MatricesList.vue?vue&type=script&lang=js&"
export * from "./MatricesList.vue?vue&type=script&lang=js&"
import style0 from "./MatricesList.vue?vue&type=style&index=0&id=2b3d4bc2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3d4bc2",
  null
  
)

export default component.exports